import React from 'react';

const Logo: React.FC = () => (
    <div>
        <img src={`static/images/login/logo.svg`} alt={`logo`}/>
    </div>
);

export default Logo;